import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Lang = "es" | "en";

interface LangState {
  lang: Lang;
  setLang: (l: Lang) => void;
}

// Idioma de la interfaz. Persistido en localStorage (como el tema). Los informes
// PDF ya son bilingües por su cuenta (app/reports/i18n.py); esto es SOLO el UI.
export const useLangStore = create<LangState>()(
  persist(
    (set) => ({
      lang: "es",
      setLang: (lang) => {
        set({ lang });
        document.documentElement.lang = lang;
      },
    }),
    { name: "lang" }
  )
);
